export { ensureFavoritesCollection } from "#ensure-favorites-collection";
